<div style="width: 300px">
	<cds-modal size="sm" [open]="authStatus === 'unauthenticated'" cdsLayer>
		<cds-modal-header>
			<h1 cdsModalHeaderHeading>
				Welcome back to MultiplAI
			</h1>
		</cds-modal-header>
		<div class="cds--modal-content" cdsLayer style="padding: 8px 16px">
<!--			<div style="height: 24px"></div>-->

			<cds-text-label style="margin-bottom: 8px" [invalid]="emailInvalid" [invalidText]="emailInvalidText">
				Email
				<input (keyup)="onKeyUpEmail($event)" (keyup.enter)="login()" size="md" name="email" [(ngModel)]="email" cdsText>
			</cds-text-label>

			<cds-text-label style="margin-top: 8px" [invalid]="passwordInvalid" [invalidText]="passwordInvalidText">
				Password
				<input (keyup)="onKeyUpPassword($event)" (keyup.enter)="login()" [(ngModel)]="password" type="password" cdsText>
			</cds-text-label>

			<cds-text-label style="margin-top: 16px">
				<span>New to MultiplAI?</span>&nbsp;
				<a (click)="navigateToPage('signup')">Create an account</a>
			</cds-text-label>

			<cds-text-label>
				<span>Forgot password?</span>&nbsp;
				<a (click)="resetPassword()">Reset password</a>
			</cds-text-label>

			<div
				@expandHeight
				*ngIf="showNotification"
				style="padding: 16px 0; overflow: hidden"
			>
				<cds-actionable-notification
					[notificationObj]="{
							type: notificationType,
							title: notificationTitle,
							showClose: true
						}"
					(close)="showNotification = false"
				></cds-actionable-notification>
			</div>

		</div>
		<cds-modal-footer>
<!--			<button href="/password" (click)="resetPassword()" cdsButton="ghost" class="cds&#45;&#45;btn">-->
<!--				Forgot password?-->
<!--			</button>-->
<!--			<button (click)="navigateToPage('signup');" cdsButton="ghost" class="cds&#45;&#45;btn">-->
<!--				Create an account-->
<!--			</button>-->
			<button cdsButton="primary" (keyup.enter)="login()" (click)="login()" class="cds--btn">
				Sign In
			</button>
<!--			<button cdsButton="secondary" size="2xl" class="cds&#45;&#45;btn">-->
<!--				Create Account-->
<!--			</button>-->
		</cds-modal-footer>
	</cds-modal>

</div>

